import React from 'react';
import styled from 'styled-components';

interface Props {}

const WrapMenu = styled.div`
  position: relative;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  background: #fff;
`;
const Menu: React.FC<Props> = (props) => {
  return (
    <WrapMenu>
      {/* <ul >
        <StyleMenuItem>
          <a href="/">Restaurant Directory</a>
        </StyleMenuItem>
        <StyleMenuItem>
          <a href="/">News</a>
        </StyleMenuItem>
        <StyleMenuItem>
          <a href="/">Guides</a>
        </StyleMenuItem>
        <StyleMenuItem>
          <a href="/">Loyalty</a>
        </StyleMenuItem>
      </ul> */}
    </WrapMenu>
  );
};

export default Menu;
